





































































import { Component, Prop, Vue } from "vue-property-decorator";
import {
  getLessonNotRollCallCountApi,
  lessonNotRollCallDelApi,
  lessonNotRollCallCountInter,
} from "@/api/lesson";
@Component({
  components: {},
})
export default class extends Vue {
  delCourseVisible = false;
  showRulesFrom = true;
  delCourseInfo = {
    lesson_date: "",
    lesson_type: -1,
  };
  statisticNum = 0;
  rules = {
    lesson_date: [{ required: true, message: "请选择日期", trigger: "change" }],
  };
  handleSearchLesson() {
    const params: lessonNotRollCallCountInter = {
      lesson_date: this.delCourseInfo.lesson_date,
    };
    if (this.delCourseInfo.lesson_type != -1) {
      params.lesson_type = this.delCourseInfo.lesson_type;
    }
    getLessonNotRollCallCountApi(params).then((res: any) => {
      if (res.error_code === 0) {
        this.statisticNum = res.data.count;
      }
    });
  }
  sureDel(num: any) {
    (this.$refs["mainForm"] as Vue & { validate: Function }).validate(
      (valid: boolean) => {
        if (valid) {
          if (this.statisticNum) {
            this.$confirm(
              `确定将 “${this.delCourseInfo.lesson_date}” 的未点名课次删除，课次删除后将不可恢复，确定要删除？`,
              `删除课次 - 共计 ${num} 未点名课次`,
              {
                showCancelButton: true,
                showConfirmButton: true,
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                confirmButtonClass: "mwow-button-filled success",
                cancelButtonClass: "mwow-button-filled info",
                iconClass: "mwow-icon-error",
              }
            )
              .then(() => {
                const data: lessonNotRollCallCountInter = {
                  lesson_date: this.delCourseInfo.lesson_date,
                };
                if (this.delCourseInfo.lesson_type != -1) {
                  data.lesson_type = this.delCourseInfo.lesson_type;
                }
                lessonNotRollCallDelApi(data).then((res: any) => {
                  if (res.error_code === 0) {
                    this.$emit("handleDelCourse");
                    this.$message({
                      type: "success",
                      message: "课次删除成功",
                    });
                    this.delCourseVisible = false;
                  }
                });
              })
              .catch(() => {});
          } else {
            this.$message({
              type: "error",
              message: "无可删除课次",
            });
          }
        }
      }
    );
  }
  showDelCourse() {
    this.delCourseVisible = true;
  }
  closeFrom() {
    this.showRulesFrom = false;
    this.delCourseInfo.lesson_date = "";
    this.delCourseInfo.lesson_type = -1;
    this.statisticNum = 0;
  }
  openFrom() {
    this.showRulesFrom = true;
  }
}
